module.exports = "/packs/images/products/collections/1-321482f5b15385e38790df1c20ebffcd.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/collections/1.png
// module id = 1804
// module chunks = 0